import { FC } from "react";

export const ActionDivision: FC = (props) => {
  return <div className="orderly-relative orderly-h-[1px] orderly-bg-base-300 orderly-mt-[-1px]"></div>;
};
